var map = {
	"./adult/de/2 1 ordkjedetekst.mp3": 750,
	"./adult/nn/2 1 ordkjedetekst.mp3": 751,
	"./adult/no/2 1 ordkjedetekst.mp3": 752,
	"./youth/de/2 1 ordkjedetekst.mp3": 753,
	"./youth/nn/2 1 ordkjedetekst.mp3": 754,
	"./youth/no/2 1 ordkjedetekst.mp3": 755,
	"./youth/se/2 1 ordkjedetekst.mp3": 756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 749;